import { useEffect, useRef } from 'react';
import { Navigate, useNavigate, useNavigationType } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import Container from '@/components/Container/Container';
import { clearCurrentSession } from '@/services/localService/localService';
import { Typography, Button, Icon } from 'br2s-ui-componentlibrary_r2_02';
import { SystemIcon } from 'br2s-ui-componentlibrary_r2_02/dist/foundation/assets/system-icon';
import './LogoutSession.scss';

interface LogoutSession {
  type: string;
}

function LogoutSession(props: LogoutSession) {
  const { type } = props;
  const navigationType = useNavigationType();

  const [, setCookie] = useCookies(['isSessionActive']);
  const navigate = useNavigate();
  const timeoutRef = useRef<number | null>(null);

  const redirectTohomePage = () => {
    navigate('/');
  };

  useEffect(() => {
    if (navigationType === 'PUSH') {
      document.body.style.overflow = 'unset';
      clearCurrentSession();
      setCookie('isSessionActive', '', { maxAge: 0, path: '/' });
      timeoutRef.current = window.setTimeout(
        () => {
          redirectTohomePage();
        },
        type === 'session' ? 30000 : 5000,
      );

      // istanbul ignore next
      return () => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, []);

  // istanbul ignore next
  if (navigationType !== 'PUSH') return <Navigate to="/" replace />;

  return (
    <Container>
      <div className="session-expired-container">
        <div
          className={
            type === 'session' ? 'session-expired-content' : 'logout-content'
          }
        >
          {type === 'session' && (
            <>
              <div className="icon-text-wrapper">
                <Icon
                  iconType="icon-sys"
                  className={`icon-sys-${SystemIcon.StateInformative}`}
                  size="size-96"
                  showLabel={false}
                  iconPosition="center"
                ></Icon>
                <Typography
                  label="Your session has timed out"
                  type="headline-3"
                  weight="bold"
                />
              </div>
              <Typography
                label="You have been logged out due to inactivity."
                type="subheadline"
                weight="regular"
              />
              <Typography
                label="Please log in again to continue your session."
                type="subheadline"
                weight="regular"
              />
              <div className="session-expired-button">
                <Button
                  id="home-page"
                  type="primary"
                  label="Go to homepage"
                  iconType="prepended"
                  iconClassName={SystemIcon.GeneralHome}
                  onClick={redirectTohomePage}
                ></Button>
              </div>
            </>
          )}
          {type === 'logout' && (
            <>
              <div className="icon-text-wrapper">
                <Icon
                  iconType="icon-sys"
                  className={`icon-sys-${SystemIcon.StateSuccess}`}
                  size="size-96"
                  showLabel={false}
                  iconPosition="center"
                ></Icon>
                <Typography
                  label="You have been successfully logged out"
                  type="headline-3"
                  weight="bold"
                />
              </div>
              <Typography
                label="You will be redirected to the homepage shortly."
                type="subheadline"
                weight="regular"
              />
              <div className="session-expired-button">
                <Button
                  id="home-page"
                  type="primary"
                  iconType="prepended"
                  iconClassName={SystemIcon.GeneralHome}
                  label="Go to homepage"
                  size="medium"
                  onClick={redirectTohomePage}
                ></Button>
              </div>
            </>
          )}
        </div>
      </div>
    </Container>
  );
}

export default LogoutSession;
